import HeroDiaryApp from "./HeroDiary";

function App() {
  return <HeroDiaryApp />;
}

export default App;
